module.exports = __webpack_public_path__ + "static/media/delixpress_logo.fbb37fa7.svg";